import { mountStandaloneApp } from '@yuksalish/ui'
import WorkSessionPage from './pages/WorkSessionPage.vue'
import PersonalKpiPage from './pages/PersonalKpiPage.vue'
import EarningsPage from './pages/EarningsPage.vue'
import { kioskMessages } from './i18n'
import './kiosk.css'
import { setupKioskMenu } from './mobileMenu'

mountStandaloneApp({
  code: 'worker-kiosk',
  title: 'Ishchi kioski',
  description: 'Sensorli ishlab chiqarish seansi, partiyani skanerlash, ishlab chiqarish, radlar, to‘xtalishlar va daromad.',
  messages: kioskMessages,
  accent: '#147a8a',
  navigation: [
    {
      label: {
        en: kioskMessages.en.kiosk.nav.workSession,
        ru: kioskMessages.ru.kiosk.nav.workSession,
        uz: kioskMessages.uz.kiosk.nav.workSession,
      },
      to: '/',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: kioskMessages.en.kiosk.nav.personalKpi,
        ru: kioskMessages.ru.kiosk.nav.personalKpi,
        uz: kioskMessages.uz.kiosk.nav.personalKpi,
      },
      to: '/kpi',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: kioskMessages.en.kiosk.nav.earnings,
        ru: kioskMessages.ru.kiosk.nav.earnings,
        uz: kioskMessages.uz.kiosk.nav.earnings,
      },
      to: '/earnings',
      permission: 'production_orders.view',
    },
  ],
  requiredPermissions: ['production_orders.view'],
  routes: [
    { path: '', component: WorkSessionPage, meta: { permission: 'production_orders.view' } },
    { path: 'kpi', component: PersonalKpiPage, meta: { permission: 'production_orders.view' } },
    { path: 'earnings', component: EarningsPage, meta: { permission: 'production_orders.view' } },
  ],
})

setupKioskMenu()
